import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
class SpartaGlobalFunctions {
  constructor() {

    spartaEventsUtility.sub(spartaEventsUtility.EVENTS.SPA_PARAMS_LOADED, (spaParams) => {
      this.spaParams = spaParams.data;
    });
  }





  spartaGetCookie(name) {
    let returnvalue = '';
    const search = `${name}=`;

    if (document.cookie.length > 0) {
      let offset = document.cookie.indexOf(search);
      if (offset !== -1) {
        offset += search.length;
        let end = document.cookie.indexOf(';', offset);
        if (end === -1) {
          end = document.cookie.length;
        }
        returnvalue = unescape(document.cookie.substring(offset, end));
      }
    }

    return returnvalue;
  }








  spartaSetCookie(name = '', value = '', days = false, domain = false) {
    let expires = '';

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toGMTString()}`;
    }

    const domainStr = (domain ? ';domain=.bankofamerica.com' : '');
    document.cookie = `${name}=${value}${expires}${domainStr}; path=/`;

    return true;
  }





  getUrlParam(name) {
    if (window.location.search.indexOf('?') < 0) {
      return null;
    }
    let result = null;
    const paramList = window.location.search.split('?')[1].split('&');
    const paramObj = {};

    paramList.forEach(paramPair => {
      const splitPair = paramPair.split('=');


      if (paramObj[splitPair[0]]) {
        paramObj[splitPair[0]] = [paramObj[splitPair[0]]];
        paramObj[splitPair[0]].push(splitPair[1]);
      } else {
        paramObj[splitPair[0]] = splitPair[1];
      }
    });

    if (paramObj[name]) {
      result = decodeURIComponent(paramObj[name]);
    }

    return result;
  }





  getGlobalParams(key) {
    const htmlLang = document.querySelector('html').getAttribute('lang');
    const lang = htmlLang ? htmlLang.toLowerCase().split("-")[0] : 'en';
    const result = this.spaParams.global[lang].globalJs[key] || '';

    return result;
  }







  mobilePhoneFormatHelper(elements) {
    const els = [...elements] || document.querySelectorAll('.spa-mobile-tel');
    els.forEach(el => {
      if (el.getAttribute('data-mobile-phone-formatted')) {
        return;
      }
      let phone = el.innerHTML.replace(/\D/g, '');
      phone = `1${phone}`;
      el.innerHTML = `<a href="tel:+${phone}">${el.innerHTML}</a>`;
      el.setAttribute('data-mobile-phone-formatted', '1');
    });
  }
}

export default new SpartaGlobalFunctions();
